import { render, staticRenderFns } from "./EditPredictionTable.vue?vue&type=template&id=5d28236c&"
import script from "./EditPredictionTable.vue?vue&type=script&lang=js&"
export * from "./EditPredictionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports